import { render } from "./App.vue?vue&type=template&id=3258468b"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3258468b&lang=css"

import exportComponent from "C:\\src\\BusinessLuchs_CRM\\frontend-public\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__